<template>
  <div>
    <div class="form-group">
      <label :for="id" class="d-flex justify-content-between">
        <span>{{ inputLabel }}</span>
        <span>
          <slot name="right-label" class=""></slot>
        </span>
      </label>
      <label :for="id" class="w-100 mb-0">
        <div class="dropzone position-relative" v-if="fileName" @drop.prevent="dropHandler" @dragover.prevent>
          <div v-if="loading" class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 0px; left: 0px; height: 100px; background-color: rgba(0,0,0,.5);">
            <div class="spinner-border text-light" style="width: 3rem; height: 3rem;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div class="dropzone-icon">
            <i class="ri-checkbox-circle-line"></i>
          </div>
          <div class="dropzone-file">
            {{ fileName }}
          </div>
          <div @click.prevent="clearFile()" class="dropzone-clearfile">
            <i class="ri-delete-bin-2-line"></i>
          </div>
        </div>
        <div class="dropzone position-relative" v-else @drop.prevent="dropHandler" @dragover.prevent>
          <div v-if="loading" class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 0px; left: 0px; height: 100px; background-color: rgba(0,0,0,.5);">
            <div class="spinner-border text-light" style="width: 3rem; height: 3rem;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <slot name="label" class="dropzone-label">
            <div class="dropzone-icon">
              <i class="ri-file-upload-line ri-lg p-2"></i>
            </div>
          </slot>
        </div>
      </label>
      <input :value="fileName" type="text" :name="name" style="display: none;">
      <input :id="id" type="file" name="uploadarea" ref="file" :class="inputClass" @change="onUpload()" style="display: none;" v-if="!disabled" />
      <input :id="id" type="file" name="uploadarea" ref="file" :class="inputClass" style="display: none;" v-else disabled="disabled" />
      <slot name="error">
      </slot>
      <input type="text" name="file_type" style="display: none;" :value="fileType">
      <input type="text" name="file_ext" style="display: none;" :value="fileExt">
    </div>
    <div v-if="error.length" class="text-danger">
      {{ error }}
    </div>
  </div>
</template>

<script>
import Compressor from 'compressorjs';
import { upload } from '../utils/s3';

export default {
  props: {
    id: String,
    name: String,
    inputClass: String,
    inputLabel: String,
    document: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      fileName: '',
      error: '',
      loading: false,
      submitBtn: '',
      btnStartState: '',
      fileType: '',
      fileExt: ''
    }
  },

  mounted() {
    const submitBtn = document.getElementById('submit-btn')

    if (submitBtn) {
      this.submitBtn = submitBtn
      this.btnStartState = `${submitBtn.innerHTML}`
    }
  },

  watch: {
    loading() {
      const oldState = `${this.submitBtn.innerHTML}`

      if (this.loading) {
        this.submitBtn.innerHTML = `
          <span class="d-flex justify-content-center align-items-center">
            <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
            Chargement du fichier...
          </span>
        `
        this.submitBtn.disabled = true
      } else {
        this.submitBtn.innerHTML = this.btnStartState
        this.submitBtn.disabled = false
      }
    }
  },

  methods: {
    onUpload() {
      const file = this.$refs.file.files[0]

      if (file) {
        if (file.size < 50000000) {
            this.fileType = file.type

            const self = this
            this.loading = true

            const fileExtension =  file.name.split('.').pop()
            const fileName = `${Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)}.${fileExtension}`

            this.fileExt = fileExtension

            upload(file, fileName, false, this.document)
              .then((data) => {
                self.error = ''
                self.fileName = data.Key

                self.loading = false
              })
              .catch((err) => {
                if (err) {
                  window.bugsnagClient.notify(err)
                }

                self.error = 'Une erreur s\'est produite pendant l\'envoi'
                self.clearFile()
                self.loading = false
              })
        } else {
            this.clearFile()
            this.error = 'Le poids du fichier est trop gros. 50 Mo maximum.'
        }
      }
    },

    clearFile() {
      this.$refs.file.value = ''
      this.fileName = ''
      this.fileExt = ''
      this.fileType = ''
    },

    dropHandler(event) {
      const files = event.dataTransfer.files;

      if (files.length > 0) {
        this.file = files[0]
      }
    }
  }
}
</script>
